import { createSelector } from 'reselect'

import identitySelector from './identity_selector'

const interactiveVideoCreationSelector = state => state.interactiveVideoCreation

const oeqSaveSelector = createSelector(
	[
		interactiveVideoCreationSelector,
		identitySelector,
	],
	(
		interactiveVideoCreation,
		identity
	) => ({
		mediaUid: identity.uid,
		jwt: identity.jwt,
		breakpointUid: interactiveVideoCreation.currentActivity.breakpointUid,
		breakpointActivityUid: interactiveVideoCreation.currentActivity.breakpointActivityUid,
		isEdition: interactiveVideoCreation.currentActivity.isEdition,
	})
)

export default oeqSaveSelector
